<template >
  <div>
    <div class="page-wrap" v-if="isShowPagesTango">
      <p class="attention mt-0 pt-0 mb-3">※1以上の数字を入力してください。</p>
      <div class="flexbox" v-for="(page, index) in pages" :key="page.id">
        <div class="flex-content mr-2 mt-2">
          {{ page.title }}
          <font color="#ff4a3d" size="2">❇︎</font>
        </div>
        <div class="flex-content mr-2">
          <v-question-number
            :numberLabel="page.start_label"
            :modelName="page.start_model"
            :value="page.start_value"
            @setNumber="(value) => setQuestionRangePage(index, value, 'start', 'tango')"
          />
        </div>
        <div class="flex-content mt-2 mr-2">
          〜
        </div>
        <div class="flex-content mr-2">
          <v-question-number
            :numberLabel="page.end_label"
            :modelName="page.end_model"
            :value="page.end_value"
            @setNumber="(value) => setQuestionRangePage(index, value, 'end', 'tango')"
          />
        </div>
        <!-- 追加ボタン -->
        <div class="flex-content">
          <button class="plus-btn" v-if="page.id === 1" v-on:click="setQuestionRangePage(lastPagesId, '', 'add', 'tango')">＋</button>
        </div>

        <!-- 削除ボタン -->
        <v-icon class="delete-btn" color="red" dark fab v-if="page.id !== 1" @click.stop="setQuestionRangePage(page.id, '', 'delete', 'tango')">
          mdi-close-circle
        </v-icon>
      </div>
    </div>

    <div class="page-wrap mt-5" v-if="isShowPagesRengo">
      <p class="attention mt-0 pt-0 mb-3">※1以上の数字を入力してください。</p>
      <div class="flexbox" v-for="(page,index) in pages2" :key="page.id">
        <div class="flex-content mr-2 mt-2">
          {{ page.title }}
          <font color="#ff4a3d" size="2">❇︎</font>
        </div>
        <div class="flex-content mr-2">
          <v-question-number
            :numberLabel="page.start_label"
            :modelName="page.start_model"
            :value="page.start_value"
            @setNumber="(value) => setQuestionRangePage(index, value, 'start', 'rengo')"
          />
        </div>
        <div class="flex-content mt-2 mr-2">
          〜
        </div>
        <div class="flex-content mr-2">
          <v-question-number
            :numberLabel="page.end_label"
            :modelName="page.end_model"
            :value="page.end_value"
            @setNumber="(value) => setQuestionRangePage(index, value, 'end', 'rengo')"
          />
        </div>

        <!-- 追加ボタン -->
        <div class="flex-content">
          <button class="plus-btn" v-if="page.id === 1" v-on:click="setQuestionRangePage(lastPage2Id, '', 'add', 'rengo')">＋</button>
        </div>

        <!-- 削除ボタン -->
        <v-icon class="delete-btn" color="red" dark fab v-if="page.id !== 1" @click.stop="setQuestionRangePage(page.id, '', 'delete', 'rengo')">
          mdi-close-circle
        </v-icon>
      </div>
    </div>
  </div>

</template>

<script>
import VQuestionNumber from '@/components/atoms/QuestionNumber'
export default {

  components: {
    VQuestionNumber
  },

  data: () => ({
    rules: {
      numeric: value => {
        let result = true
        if (value !== '0' && !value) result = '数字のみで入力してください'
        return result
      },
    },
    lastPagesId: 1,
    lastPage2Id: 1,
  }),

  computed: {
    rangeData() {
      return this.$store.state.conditions.selectedQuestionRangePage;
    },
    // 単語ページ範囲
    isShowPagesTango() {
      return this.$store.getters['conditions/isShowPagesTango']
    },
    // 連語ページ範囲
    isShowPagesRengo() {
      return this.$store.getters['conditions/isShowPagesRengo']
    },
    pages() {
      //ページ数入力欄：単語用(storeのselectedQuestionRangePage.tangoの値から入力欄を生成する)
      let pages = Object.entries(this.rangeData.tango).map((item,index) => {
        return {
          id: index+1,
          title: '単語',
          start_label: 'ページ数',
          start_model: 'page_start',
          start_value: item[1].start ? item[1].start : '',
          end_label: 'ページ数',
          end_model: 'page_end',
          end_value: item[1].end ? item[1].end : '',
        }
      })
      return pages
    },
    pages2() {
      //ページ数入力欄：連語用(storeのselectedQuestionRangePage.rengoの値から入力欄を生成する)
      let pages2 = Object.entries(this.rangeData.rengo).map((item,index) => {
        return {
          id: index+1,
          title: '連語',
          start_label: 'ページ数',
          start_model: 'page_start',
          start_value: item[1].start ? item[1].start : '',
          end_label: 'ページ数',
          end_model: 'page_end',
          end_value: item[1].end ? item[1].end : '',
        }
      })
      return pages2
    },
  },

  mounted() {
  },

  methods: {
    setQuestionRangePage(index, value, type, word) {
      //呼び出し元で処理タイプの指定をしている
      if(type === 'add')
        if(word === 'tango') this.lastPagesId += 1
        else if(word === 'rengo') this.lastPage2Id += 1
      else if(type === 'delete')
      //TODO:削除時のindex指定がおかしいのか入力欄２つの場合削除できていない
        if(word === 'tango') index = this.pages.findIndex(page => page.id === index)
        else if(word === 'rengo') index = this.pages2.findIndex(page => page.id === index)
      this.$store.commit('conditions/setSelectedQuestionRangePage', {
        type: type,
        index: index,
        value: value,
        word: word
      })
    },
  },

  watch: {
  }
}
</script>

<style lang="stylus" scoped>
  .materials
    max-width 800px

  .flexbox
    display flex

  .plus-btn
    box-sizing: border-box;
    font-weight bold
    text-align center
    padding 8px 0
    margin: 0;
    width: 2em;
    border-radius 3px
    cursor pointer
    position relative
    position: relative;
    color: #fff;
    background-color: #aaa;

  .delete-btn
    height: 40px;

  .attention
    font-size 12px

</style>
